import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from "../../services/api";

export const login = createAsyncThunk('auth/login', async (credentials) => {
  const res = await apiClient.post('/auth/login', credentials);
  localStorage.setItem('token', res.data.token);
  localStorage.setItem('user', JSON.stringify(res.data.user));
  return res.data;
});

export const logout = createAsyncThunk('auth/logout', async () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  return { type: 'auth/logout' };
});

export const resetAuthError = createAsyncThunk('auth/resetError', () => {
  return { type: 'auth/resetError' };
});

export const resetPassword = createAsyncThunk('auth/resetPassword', async (email) => {
  const res = await apiClient.post('/users/forgot-password', { email });
  return res.data;
});

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token'),
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.token = null;
        state.status = 'idle';
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.user = action.payload.user;
        state.token = 'token';
        state.status = 'succeeded';
      })
      .addCase(resetAuthError.fulfilled, (state) => {
        state.error = null;
      })
      .addCase(login.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
});

export default authSlice.reducer;
